import { message } from 'antd';
import { detectWebView } from './jsbridge';

/**
 * 兼容WebView的复制到剪贴板函数
 * @param {string} text - 要复制的文本
 * @param {string} successMessage - 复制成功的提示文案，默认为'复制成功'
 * @returns {Promise<boolean>} - 复制成功返回true，失败返回false
 */
export async function copyToClipboard(text, successMessage = '复制成功') {
  // 检测是否在WebView环境中
  const webViewInfo = detectWebView();
  
  // 在WebView环境中尝试使用不同的方法
  if (webViewInfo.isWebView) {
    // 尝试使用React Native WebView的postMessage方法
    if (window.ReactNativeWebView) {
      try {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'COPY_TO_CLIPBOARD',
          payload: text
        }));
        message.success(successMessage);
        return true;
      } catch (err) {
        console.warn('Failed to copy using ReactNativeWebView postMessage:', err);
      }
    }
    
    // 对于WebView环境，也尝试使用传统的document.execCommand方法作为备选方案
    try {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      
      // 避免滚动到底部
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      
      if (successful) {
        message.success(successMessage);
        return true;
      }
    } catch (err) {
      console.warn('Failed to copy using execCommand:', err);
    }
  }
  
  // 标准浏览器环境使用Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      message.success(successMessage);
      return true;
    } catch (err) {
      console.warn('Failed to copy using Clipboard API:', err);
    }
  }
  
  // 如果Clipboard API不可用，则回退到execCommand方法
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // 避免滚动到底部
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    
    if (successful) {
      message.success(successMessage);
      return true;
    }
  } catch (err) {
    console.error('Failed to copy text to clipboard:', err);
    return false;
  }
  
  // 所有方法都失败
  return false;
}

export default copyToClipboard;